import { all, fork } from "redux-saga/effects";

//public
import LoginSaga from "./Login/saga";
import UserSaga from "./User/saga";
import fileUpload from "./Upload Image/saga";
import ExportUserSaga from "./ExportUser/saga";
import FaqSaga from "./Faq/saga";
import ContentpageSaga from "./ContentPage/saga";
import SystemAdminSaga from "./SystemAdmin/saga";
import SettingSaga from "./Settings/saga";
import CatalogSaga from "./Catalog/saga";
import DashboardSaga from "./Dashboard/saga";
import ExportSaga from "./Export/saga";
import DocumentsSaga from "./Documents/saga";
import TemplatesSaga from "./Templates/saga";
import CategorySaga from "./Category/saga";
import EmailTempSaga from "./EmailTemp/saga";
import SignatureSaga from "./Signature/saga";
import DocumentCategorySaga from "./DocumentCategory/saga";
import DeleteSubscriberSaga from "./DeleteSubscriber/saga";

export default function* rootSaga() {
  yield all([fork(LoginSaga)]);
  yield all([fork(UserSaga)]);
  yield all([fork(DocumentsSaga)]);
  yield all([fork(TemplatesSaga)]);
  yield all([fork(fileUpload)]);
  yield all([fork(ExportUserSaga)]);
  yield all([fork(FaqSaga)]);
  yield all([fork(ContentpageSaga)]);
  yield all([fork(SystemAdminSaga)]);
  yield all([fork(SettingSaga)]);
  yield all([fork(CatalogSaga)]);
  yield all([fork(DashboardSaga)]);
  yield all([fork(ExportSaga)]);
  yield all([fork(CategorySaga)]);
  yield all([fork(DocumentCategorySaga)]);
  yield all([fork(EmailTempSaga)]);
  yield all([fork(SignatureSaga)]);
  yield all([fork(DeleteSubscriberSaga)]);
}
